import React from 'react';
import { Alert, AlertColor, Stack } from '@mui/material';
import { TwilioCustomerProfileEvaluationType } from 'types/twilio/twilioCustomerProfile';

interface TwilioCustomerProfileProps {
  customerProfileEvaluation: TwilioCustomerProfileEvaluationType;
}

export const TwilioCustomerProfileEvaluation = ({
  customerProfileEvaluation,
}: TwilioCustomerProfileProps) => {
  const statusColor: AlertColor =
    customerProfileEvaluation.status === 'compliant' ? 'success' : 'error';

  return (
    <div>
      <div className="d-flex justify-content-center mt-4">
        <Alert severity={statusColor}>{customerProfileEvaluation.status}</Alert>
      </div>

      {customerProfileEvaluation.status === 'compliant' ? (
        <p className="text-center mt-2">There are no errors</p>
      ) : (
        <Stack spacing={2} margin={2}>
          {customerProfileEvaluation.results
            .filter(({ passed }) => !passed)
            .map(({ failure_reason, friendly_name }) => (
              <div key={friendly_name}>
                <span className="font-weight-bold">{friendly_name}</span> - {failure_reason}
              </div>
            ))}
        </Stack>
      )}
    </div>
  );
};
